window.addEventListener('turbo:load', (event) => {
  const form = document.getElementById('spend-one-time-login-token-form');
  if (!form) {
    return;
  }
  form.submit();
});